import { create } from "zustand";

/** DOM host state only. Session membership and requests live in the sidebar session. */
interface FollowUpSidebarHostState {
  container: HTMLDivElement | null;
  hideCloseButton: boolean;
  hostMounted: boolean;
  setHostMounted: (mounted: boolean) => void;
  setContainer: (
    container: HTMLDivElement | null,
    hideCloseButton?: boolean,
  ) => void;
}
export const useFollowUpSidebarHostStore = create<FollowUpSidebarHostState>(
  (set) => ({
    container: null,
    hideCloseButton: false,
    hostMounted: false,
    setHostMounted: (hostMounted) => set({ hostMounted }),
    setContainer: (container, hideCloseButton = false) =>
      set({ container, hideCloseButton }),
  }),
);
